import React from "react";
import "../Style/Feed.css";
import Post from "./Posts/QuestionPost";
import QuestionBox from "./QuestionBox";

function Feed({ posts }) {
  return (
    <div className="feed">
      <QuestionBox />
      {posts.map(({ answers, questionId, question }) => (
        <Post
          key={questionId}
          questionId={questionId}
          question={question.question}
          category={question.option}
          timestamp={question.timestamp}
          buildFaastUser={question.user}
          answers={answers}
        />
      ))}
    </div>
  );
}

export default Feed;
